import React, { useState } from "react";
import Modal from "react-modal";
import "./var-sheet.scss";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
const MySwal = withReactContent(Swal);
import { updateVarSheet } from "../../../api";

function VarSheetModal({ show, close, data, appId }) {
    const [formData, setFormData] = useState({
        ems_mid: data?.ems_mid ? data?.ems_mid : "",
        model: data?.model ? data?.model : "",
        build_notes: data?.build_notes ? data?.build_notes : "",
        office: data?.office ? data?.office : "",
        rep_code: data?.rep_code ? data?.rep_code : "",
        branch: data?.branch ? data?.branch : "",
        merchant: data?.merchant ? data?.merchant : "",
        v_number: data?.v_number ? data?.v_number : "",
        tpn: data?.tpn ? data?.tpn : "",
        amex: data?.amex ? data?.amex : "",
        discover: data?.discover ? data?.discover : "",
        platform_host: data?.platform_host ? data?.platform_host : "",
        bin: data?.bin ? data?.bin : "",
        agent: data?.agent ? data?.agent : "",
        chain: data?.chain ? data?.chain : "",
        store: data?.store ? data?.store : "",
        country_code: data?.country_code ? data?.country_code : "",
        terminal: data?.terminal ? data?.terminal : "",
        currency_code: data?.currency_code ? data?.currency_code : "",
        sic_code: data?.sic_code ? data?.sic_code : "",
        time_zone: data?.time_zone ? data?.time_zone : "",
        location: data?.location ? data?.location : "",
        zip_code: data?.zip_code ? data?.zip_code : "",
        authorization_settlement_url: data?.authorization_settlement_url
            ? data?.authorization_settlement_url
            : "",
        authorization_settlement_port: data?.authorization_settlement_port
            ? data?.authorization_settlement_port
            : "",
        authorization_phone: data?.authorization_phone
            ? data?.authorization_phone
            : "",
        settlement_phone: data?.settlement_phone ? data?.settlement_phone : "",
        merchant_name: data?.merchant_name ? data?.merchant_name : "",
        address: data?.address ? data?.address : "",
        city: data?.city ? data?.city : "",
        state: data?.state ? data?.state : "",
        phone: data?.phone ? data?.phone : "",
        software: data?.software ? data?.software : "",
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const onSubmitClick = () => {
        MySwal.fire({
            title: "Are you sure? Want to edit",
            text: "Want to edit VAR sheet!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, Update it!",
            customClass: "sweet-alert-class",
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                updateVarSheet(formData, appId)
                    .then((res) => {
                        if (res.status) {
                            close();
                            MySwal.fire({
                                title: "Updated!",
                                text: "VAR Sheet updated successfully.",
                                icon: "success",
                                timer: 750,
                            });
                        } else {
                            MySwal.fire({
                                title: "Something went wrong!!",
                                text: "Something went wrong!!.",
                                icon: "error",
                                timer: 750,
                            });
                        }
                    })
                    .catch((err) => {
                        MySwal.fire({
                            title: "Something went wrong!!",
                            text: "Something went wrong!!.",
                            icon: "error",
                            timer: 750,
                        });
                    });
            }
        });
    };

    return (
        <Modal
            isOpen={show}
            contentLabel="VAR Sheet Modal"
            className={"var_sheet_modal"}
        >
            <div className="header">
                <h1>VAR Sheet</h1>
            </div>
            <div className="body">
                <form>
                    <div className="row">
                        <div className="col-md-3">
                            <div className="form-group">
                                <label>EMS MID</label>
                                <input
                                    type="text"
                                    name="ems_mid"
                                    value={formData.ems_mid}
                                    onChange={handleChange}
                                    className="form-control"
                                />
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="form-group">
                                <label>Model</label>
                                <input
                                    type="text"
                                    name="model"
                                    value={formData.model}
                                    onChange={handleChange}
                                    className="form-control"
                                />
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="form-group">
                                <label>Build Notes</label>
                                <input
                                    type="text"
                                    name="build_notes"
                                    value={formData.build_notes}
                                    onChange={handleChange}
                                    className="form-control"
                                />
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="form-group">
                                <label>Office</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="office"
                                    value={formData.office}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-3">
                            <div className="form-group">
                                <label>Rep Code</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="rep_code"
                                    value={formData.rep_code}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="form-group">
                                <label>Branch</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="branch"
                                    value={formData.branch}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="form-group">
                                <label>Merchant</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="merchant"
                                    value={formData.merchant}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="form-group">
                                <label>V#</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="v_number"
                                    value={formData.v_number}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-3">
                            <div className="form-group">
                                <label>TPN</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="tpn"
                                    value={formData.tpn}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="form-group">
                                <label>Discover</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="discover"
                                    value={formData.discover}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="form-group">
                                <label>Platform (Host)</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="platform_host"
                                    value={formData.platform_host}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="form-group">
                                <label>BIN#</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="bin"
                                    value={formData.bin}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-3">
                            <div className="form-group">
                                <label>Agent</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="agent"
                                    value={formData.agent}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="form-group">
                                <label>Chain</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="chain"
                                    value={formData.chain}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="form-group">
                                <label>Store</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="store"
                                    value={formData.store}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="form-group">
                                <label>Country Code</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="country_code"
                                    value={formData.country_code}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-3">
                            <div className="form-group">
                                <label>Terminal</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="terminal"
                                    value={formData.terminal}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="form-group">
                                <label>Currency Code</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="currency_code"
                                    value={formData.currency_code}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="form-group">
                                <label>SIC Code</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="sic_code"
                                    value={formData.sic_code}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="form-group">
                                <label>Time Zone</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="time_zone"
                                    value={formData.time_zone}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-3">
                            <div className="form-group">
                                <label>Location#</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="location"
                                    value={formData.location}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="form-group">
                                <label>Zip Code</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="zip_code"
                                    value={formData.zip_code}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="form-group">
                                <label>Authorization/Settlement URL</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="authorization_settlement_url"
                                    value={
                                        formData.authorization_settlement_url
                                    }
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="form-group">
                                <label>Authorization/Settlement Port #</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="authorization_settlement_port"
                                    value={
                                        formData.authorization_settlement_port
                                    }
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-3">
                            <div className="form-group">
                                <label>Authorization Phone #</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="authorization_phone"
                                    value={formData.authorization_phone}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="form-group">
                                <label>Settlement Phone #</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="settlement_phone"
                                    value={formData.settlement_phone}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="form-group">
                                <label>Merchant Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="merchant_name"
                                    value={formData.merchant_name}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="form-group">
                                <label>Address</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="address"
                                    value={formData.address}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-3">
                            <div className="form-group">
                                <label>City</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="city"
                                    value={formData.city}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="form-group">
                                <label>State</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="state"
                                    value={formData.state}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="form-group">
                                <label>Phone</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="form-group">
                                <label>Software</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="software"
                                    value={formData.software}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-3">
                            <div className="form-group">
                                <label>Amex</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="amex"
                                    value={formData.amex}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div className="footer">
                <button
                    type="button"
                    onClick={() => close()}
                    className="btn-close"
                >
                    Close
                </button>
                <button
                    type="button"
                    onClick={() => onSubmitClick()}
                    className="btn-save"
                >
                    Save
                </button>
            </div>
        </Modal>
    );
}

export default VarSheetModal;
